module.exports = __webpack_public_path__ + "static/z7e-map2-93ba91dd6a2752a06498e735244cbfe7.jpg";